export default {
  SET_REPORT_FILTERS(state, payload) {
    state.filters = [...payload]
  }
}
